var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Papa from 'papaparse';
import { Button, Typography, Alert } from '@one-thd/sui-atomic-components';
import { FormProvider, useForm } from 'react-hook-form';
import { mapCSVDataToFormValuesModel } from '../../../../utils/bulk-add';
import { StepOne } from './instructions/step1';
import { StepTwo } from './instructions/step2';
import { StepThree } from './instructions/step3';
import { getInvalidFileTypeMessage, FILE_IS_REQUIRED, } from '../../../../constants/field-error-messages';
import { setBulkAddEventAnalytics, setUserPostPageErrorAnalytics, } from '../../../../utils/add-manage-user-analytics';
export var Upload = function (_a) {
    var onSubmit = _a.onSubmit;
    var formMethods = useForm();
    var _b = React.useState(), csvFile = _b[0], setCsvFile = _b[1];
    var register = formMethods.register, handleSubmit = formMethods.handleSubmit, setError = formMethods.setError, clearErrors = formMethods.clearErrors, errors = formMethods.formState.errors;
    var onSubmitUserInfo = function () {
        if (csvFile) {
            Papa.parse(csvFile, {
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: function (results) {
                    var data = mapCSVDataToFormValuesModel(results.data);
                    onSubmit(data);
                },
            });
        }
        else {
            setError('csvFile', {
                type: 'required',
                message: FILE_IS_REQUIRED.message,
            });
            setUserPostPageErrorAnalytics('bulk add', 'inline', 'n/a', FILE_IS_REQUIRED.message);
        }
    };
    var onInputFileClick = function () {
        var _a;
        setBulkAddEventAnalytics('upload template click');
        (_a = document.getElementById('csvFile')) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, { variant: "h4" }, "How to Bulk Add Users From a CSV File")),
        React.createElement(StepOne, null),
        React.createElement(StepTwo, null),
        React.createElement(StepThree, null),
        React.createElement("div", { "data-testid": "upload-instructions-step4", className: "sui-flex sui-mb-6" },
            React.createElement("div", { className: "sui-min-w-[60px] sui-text-lg" },
                React.createElement(Typography, { weight: "bold" }, "Step 4:")),
            React.createElement(Typography, null, "Upload CSV file below to import user data.")),
        errors.csvFile && React.createElement(Alert, { status: "error" }, errors.csvFile.message),
        React.createElement(FormProvider, __assign({}, formMethods),
            React.createElement("form", { onSubmit: handleSubmit(onSubmitUserInfo) },
                React.createElement("div", { className: "sui-flex sui-justify-end sui-items-center sui-gap-x-4 md:sui-grid-cols-2 sui-mb-6" },
                    React.createElement("div", null,
                        React.createElement("input", __assign({ "data-testid": "file-input", type: "file", id: "csvFile", hidden: true }, register('csvFile'), { onChange: function (event) {
                                var _a;
                                var file = (_a = event.target) === null || _a === void 0 ? void 0 : _a.files;
                                if (file && file[0]) {
                                    if (file[0].type !== 'text/csv') {
                                        setError('csvFile', {
                                            type: 'validated',
                                            message: getInvalidFileTypeMessage(file[0].name),
                                        });
                                        setUserPostPageErrorAnalytics('bulk add', 'inline', 'n/a', getInvalidFileTypeMessage(file[0].name));
                                    }
                                    else {
                                        setCsvFile(file[0]);
                                        clearErrors('csvFile');
                                    }
                                }
                            } })),
                        React.createElement(Button, { "data-testid": "upload-button", type: "button", variant: "secondary", fullWidth: true, onClick: onInputFileClick }, "Upload CSV File")),
                    (csvFile === null || csvFile === void 0 ? void 0 : csvFile.name) && (React.createElement("div", { className: "sui-max-w-[160px] md:sui-max-w-[200px] lg:sui-max-w-[300px]" },
                        React.createElement(Typography, { truncate: true, "data-testid": "file-name-preview" }, csvFile === null || csvFile === void 0 ? void 0 : csvFile.name))),
                    React.createElement("div", null,
                        React.createElement(Button, { "data-testid": "submit-button", type: "submit", disabled: Boolean(errors.csvFile), fullWidth: true }, "Import Users")))))));
};
